var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 24.42V27.956C29.0001 28.2092 28.9042 28.453 28.7316 28.6382C28.559 28.8234 28.3226 28.9363 28.07 28.954C27.633 28.984 27.276 29 27 29C18.163 29 11 21.837 11 13C11 12.724 11.015 12.367 11.046 11.93C11.0637 11.6774 11.1766 11.441 11.3618 11.2684C11.547 11.0958 11.7908 10.9999 12.044 11H15.58C15.704 10.9999 15.8237 11.0459 15.9157 11.129C16.0078 11.2122 16.0656 11.3266 16.078 11.45C16.101 11.68 16.122 11.863 16.142 12.002C16.3407 13.3889 16.748 14.7378 17.35 16.003C17.445 16.203 17.383 16.442 17.203 16.57L15.045 18.112C16.3645 21.1865 18.8145 23.6365 21.889 24.956L23.429 22.802C23.4919 22.714 23.5838 22.6509 23.6885 22.6237C23.7932 22.5964 23.9042 22.6068 24.002 22.653C25.267 23.2539 26.6156 23.6601 28.002 23.858C28.141 23.878 28.324 23.9 28.552 23.922C28.6752 23.9346 28.7894 23.9926 28.8724 24.0846C28.9553 24.1766 29.0012 24.2961 29.001 24.42H29Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.285df106689ccb2ff500c3acb49c6516.svg";
export { ForwardRef as ReactComponent };